module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ca-Db-Ee.e2ca9301.png";